import menuItems from "./menuItems";

let cart = window.localStorage.getItem("cart");
let deliverytype = window.localStorage.getItem("deliverytype");
let deliverydistance = window.localStorage.getItem("deliverylocation");
//let additionalcharges = window.localStorage.getItem('charges')

const getDefaultCartState = () => {
  return {
    cart: cart ? JSON.parse(cart) : [],
    ordertype: deliverytype ? deliverytype : null,
    gst: [],
    charges: [],
    carttotal: 0,
    cart_status: "",
    distance: deliverydistance ? deliverydistance : 0,
    order_later: false,
    order_now: true,
    orderdate: "",
    ordertime: "",
    coupon_code_name: "",
    applied_promo_disc_amt: 0,
    coupan_code_type: "",
    coupan_code_id: "",
  };
};

/*
const state = {
    cart: cart ? JSON.parse(cart) : [],
    ordertype: deliverytype ? deliverytype : null,
    gst: [],
    charges: [],
    carttotal: 0,
    cart_status: "",
    distance: deliverydistance ? deliverydistance : 0
};*/

// initial state
const state = getDefaultCartState();

const getters = {
  // cartItemCount: state => state.cart.length,
  cartItemCount: (state) => {
    let cartitems = 0;
    state.cart.forEach((element) => {
      // console.log("cartItemCount "+ JSON.stringify(element.quantity))
      cartitems = cartitems + element.quantity;
    });

    // console.log("cartitems "+cartitems)
    return cartitems;
  },
  cartItems: (state) => state.cart,
  cartTotalPrice: (state) => {
    let total = 0;
    let charge = 0;

    if (state.cart.length != 0) {
      state.cart.forEach((element) => {
        //console.log("Charge array is "+ JSON.stringify(element.add_charge))

        let addon_optgrp_price = element.item.items.addon_optgrp_price;
        ///   let discount_calculated_on_add_opt = element.item.items.discount_calculated_on_add_opt

        // console.log("addon_optgrp_price "+ addon_optgrp_price)
        // console.log("discount_calculated_on_add_opt "+ discount_calculated_on_add_opt)

        if (addon_optgrp_price == 0) {
          element.add_charge.find((addCharge) => {
            charge = addCharge.calculated_charge_amt;

            total += charge;
          });

          let discounted_price = element.item.items.discounted_price;

          if (discounted_price == 0) {
            total += element.item.items.sale_price * element.quantity;
          } else {
            total += discounted_price * element.quantity;
          }
        } else {
          element.add_charge.find((addCharge) => {
            charge = addCharge.calculated_charge_amt;

            total += charge;
          });

          let discounted_price = element.item.items.discounted_price;

          if (discounted_price == 0) {
            total += addon_optgrp_price * element.quantity;
          } else {
            total += addon_optgrp_price;
          }
        }
        //  console.log("total after adding charge is "+total)
      });
    }

    //  console.log("final total after adding charges is "+total)

    state.carttotal = total;

    //console.log("state.carttotal "+state.carttotal)

    return total;
  },
  cartGST: (state) => {
    let is_devidable = 0;
    let gst = 0;
    let cgst_per = 0;
    let sgst_per = 0;
    let cgst = 0;
    let sgst = 0;
    let total = 0;
    let tax_inex_method = 0;
    let tax_name = "";
    let tax = "";
    // let tax_value = 0
    // console.log("cart "+JSON.stringify(state.cart))

    if (state.cart.length != 0) {
      state.cart.forEach((element) => {
        //  console.log("element "+JSON.stringify(element))
        // console.log("element "+element.item.items.addon_optgrp_price)
        //  console.log("element.item.items.tax_per "+element.item.items.tax_per)

        let addon_optgrp_price = element.item.items.addon_optgrp_price;
        // let discount_calculated_on_add_opt = element.item.items.discount_calculated_on_add_opt
        //let addon_opt_qty = element.quantity

        if (addon_optgrp_price == 0) {
          is_devidable = element.item.items.is_devidable;
          gst = element.item.items.tax_per;
          if (gst > 0) {
            tax_name = element.item.items.tax_name;
            cgst_per = gst / 2;
            sgst_per = gst / 2;
            tax_inex_method = element.item.items.tax_method;
            if (tax_inex_method == 1) {
              let discounted_price = element.item.items.discounted_price;
              if (discounted_price == 0) {
                total += element.item.items.tax_value;
              } else {
                total += element.item.items.tax_value;
              }

              tax = "Incl.";
            } else {
              let discounted_price = element.item.items.discounted_price;

              if (discounted_price == 0) {
                let tax_value =
                  Math.round(
                    ((element.item.items.sale_price / 100) * gst +
                      Number.EPSILON) *
                      100
                  ) / 100;
                // console.log("tax_value "+tax_value)
                total += tax_value;
              } else {
                let tax_value =
                  Math.round(
                    ((discounted_price / 100) * gst + Number.EPSILON) * 100
                  ) / 100;

                total += tax_value;
              }

              tax = "Excl.";
            }

            cgst = (total * element.quantity) / 2;
            sgst = (total * element.quantity) / 2;
          }
        } else {
          is_devidable = element.item.items.is_devidable;
          gst = element.item.items.tax_per;
          if (gst > 0) {
            tax_name = element.item.items.tax_name;
            cgst_per = gst / 2;
            sgst_per = gst / 2;
            tax_inex_method = element.item.items.tax_method;

            if (tax_inex_method == 1) {
              let tax_value =
                Math.round(
                  ((addon_optgrp_price / 100) * gst + Number.EPSILON) * 100
                ) / 100;
              total += tax_value;

              tax = "Incl.";
            } else {
              let tax_value =
                Math.round(
                  ((addon_optgrp_price / 100) * gst + Number.EPSILON) * 100
                ) / 100;
              total += tax_value;

              tax = "Excl.";
            }

            /* if (element.item.items.order_child_options.length === 0) {
              if (tax_inex_method == 1) {
                let tax_value =
                  Math.round(
                    ((addon_optgrp_price / 100) * gst + Number.EPSILON) * 100
                  ) / 100;
                total += tax_value;

                tax = "Incl.";
              } else {
                let tax_value =
                  Math.round(
                    ((addon_optgrp_price / 100) * gst + Number.EPSILON) * 100
                  ) / 100;
                total += tax_value;

                tax = "Excl.";
              }
            } else {
              element.item.items.order_child_options.forEach((option_group) => {
                if (tax_inex_method == 1) {
                  let discounted_price = element.item.items.discounted_price;

                  if (discounted_price == 0) {
                    let tax_value =
                      Math.round(
                        ((addon_optgrp_price / 100) * gst + Number.EPSILON) *
                          100
                      ) / 100;

                    tax_value;


                    total += option_group.tax_value;
                  } else {
                    total += option_group.tax_value;
                  }

                  tax = "Incl.";
                } else {
                  //console.log("add on gst exclusive");
                  //let discounted_price = element.item.items.discounted_price;
                    if (discounted_price == 0) {
                    // total += addon_optgrp_price * element.quantity

                    total += option_group.tax_value;
                  } else {
                  let tax_value =
                    Math.round(
                      ((addon_optgrp_price / 100) * gst + Number.EPSILON) * 100
                    ) / 100;

                  console.log("tax value " + tax_value);
                  total += tax_value;
                   }

                  tax = "Excl.";
                }
              });
            }
 */
            console.log("total " + total);

            // cgst = Math.round((((total / 100) * cgst_per) + Number.EPSILON) * 100) / 100
            // sgst = Math.round((((total / 100) * sgst_per) + Number.EPSILON) * 100) / 100

            // console.log("tax value "+element.item.items.tax_value)

            cgst = (total * element.quantity) / 2;
            sgst = (total * element.quantity) / 2;
            //   console.log("cgst "+cgst)
            //  console.log("sgst "+sgst)
          }
        }

        // alert("element.item.items.tax_value is "+element.item.items.tax_value)
        element.item.items.tax_value = cgst + sgst;
        // alert("second element.item.items.tax_value is "+element.item.items.tax_value)
      });
    }

    state.gst.push({
      cgst: cgst,
      sgst: sgst,
      gstper: gst,
      tax_inex_method: tax_inex_method,
      is_devidable: is_devidable,
      cgst_per: cgst_per,
      sgst_per: sgst_per,
      total: total,
      tax_name: tax_name,
      tax: tax,
    });

    return state.gst[state.gst.length - 1];
  },
  getOrderType: (state) => state.ordertype,
  getAdditionalCharges: (state) => {
    //  console.log("charges log is "+ state.charges)
    // console.log("additional charge cart "+JSON.stringify(menuItems.state.charges));

    //  alert("HEllo")

    let charge_name;
    let charge_type;
    let charge_amt;
    let finaltotal = 0;
    let charge_applicable_on;
    state.charges = [];
    let is_tax_applicable = 0;
    let tax_amount = 0;
    let tax_on_additional_tax = 0;

    // console.log("state.cart.length "+state.cart.length)
    //console.log("menuItems.state.charges "+menuItems.state.charges.length)

    if (state.cart.length > 0) {
      menuItems.state.charges.find((chargesItem) => {
        charge_applicable_on = chargesItem.charge_applicable_on;

        let selected_order_type = 0;
        /*
                delivery
                pickup
                dinein
                */
        if (state.ordertype == "delivery") {
          selected_order_type = 2;
        } else if (state.ordertype == "pickup") {
          selected_order_type = 3;
        } else if (state.ordertype == "dinein") {
          selected_order_type = 1;
        }

        if (
          selected_order_type == chargesItem.digi_order_type ||
          chargesItem.digi_order_type == 0
        ) {
          // console.log("in selected order type block")
          if (charge_applicable_on === 0 || charge_applicable_on === 2) {
            if (chargesItem.per_or_fixed == 0) {
              //  console.log("in per_or_fixed if block")
              let total = 0;
              charge_name = chargesItem.title;
              charge_type = chargesItem.amount;
              charge_amt = chargesItem.amount;
              total = total + charge_amt;

              //  console.log("first total is "+total)
              is_tax_applicable = chargesItem.is_tax_applicable;
              tax_amount = chargesItem.tax_amount;

              if (is_tax_applicable === 1) {
                tax_on_additional_tax =
                  Math.round(
                    ((charge_amt / 100) * tax_amount + Number.EPSILON) * 100
                  ) / 100;
                total = total + tax_on_additional_tax;
              }

              // delivery_applicable_platform = 0 (Atlantic) AND delivery_applicable_platform = 1 (Digital order)

              //console.log("deliverylocation in fixed "+state.distance)
              //console.log("total in fixed "+total)
              if (
                chargesItem.delivery_applicable_platform == 1 &&
                selected_order_type == 2
              ) {
                total = state.distance * total;
              }

              finaltotal = finaltotal + total;
              console.log("1 finaltotal is " + finaltotal);
              console.log("1 total is " + total);

              if (
                state.carttotal < chargesItem.delivery_free_afteramount ||
                chargesItem.delivery_free_afteramount == 0
              ) {
                // total = 0;
                //finaltotal = 0;

                let per_or_fixed = chargesItem.per_or_fixed;
                state.charges.push({
                  charge_name,
                  charge_type,
                  charge_amt,
                  total,
                  charge_applicable_on,
                  tax_amount,
                  tax_on_additional_tax,
                  per_or_fixed,
                  delivery_applicable_platform:
                    chargesItem.delivery_applicable_platform,
                  finaltotal,
                });
              }
            } else {
              //console.log("in per_or_fixed else block")
              let total = 0;
              charge_name = chargesItem.title;

              charge_type = chargesItem.amount + "%";
              (charge_amt = (state.carttotal / 100) * chargesItem.amount),
                (total = total + charge_amt);

              is_tax_applicable = chargesItem.is_tax_applicable;
              tax_amount = chargesItem.tax_amount;

              if (is_tax_applicable === 1) {
                tax_on_additional_tax =
                  Math.round(
                    ((charge_amt / 100) * tax_amount + Number.EPSILON) * 100
                  ) / 100;

                total = total + tax_on_additional_tax;
              }

              // console.log("deliverylocation in percentage " + state.distance)
              //  console.log("total in percentage " + total)

              if (
                chargesItem.delivery_applicable_platform == 1 &&
                selected_order_type == 2
              ) {
                total = state.distance * total;
              }

              finaltotal = finaltotal + total;

              if (
                state.carttotal < chargesItem.delivery_free_afteramount ||
                chargesItem.delivery_free_afteramount == 0
              ) {
                let per_or_fixed = chargesItem.per_or_fixed;
                state.charges.push({
                  charge_name,
                  charge_type,
                  charge_amt,
                  total,
                  charge_applicable_on,
                  tax_amount,
                  tax_on_additional_tax,
                  per_or_fixed,
                  delivery_applicable_platform:
                    chargesItem.delivery_applicable_platform,
                  finaltotal,
                });
              }

              //console.log("charges in else block "+JSON.stringify(state.charges))
            }
          }
        }
      });
    }
    return state.charges;
  },
  cart_update_status: (state) => state.cart_status,
  getDistance: (state) => state.distance,
  getOrderLater: (state) => state.order_later,
  getOrderNow: (state) => state.order_now,
  getOrderDate: (state) => state.orderdate,
  getOrderTime: (state) => state.ordertime,
  getCoupanName: (state) => state.coupon_code_name,
  getCoupanAmount: (state) => state.applied_promo_disc_amt,
  getCoupanID: (state) => state.coupan_code_id,
  getCoupanType: (state) => state.coupan_code_type,
};

const actions = {
  async addMenuToCart({ commit }, item) {
    let quantity = 1;
    commit("ADD_TO_CART", {
      item,
      quantity,
      commit,
    });
  },

  async removeProductFromCart({ commit }, { item_id, item }) {
    commit("REMOVE_PRODUCT_FROM_CART", {
      item_id,
      commit,
      item,
    });
  },

  async clearCartItems({ commit }) {
    commit("CLEAR_CART_ITEMS", {
      commit,
    });
  },

  async deleteFromCart({ commit }, { item_id, quantity, item }) {
    /*  commit,
          item_id
          quantity
          console.log("item is in deleteFromCart "+JSON.stringify(item))*/
    commit("DELETE_PRODUCT_FROM_CART", {
      item_id,
      quantity,
      commit,
      item,
    });
  },

  async saveOrderType({ commit }, { ordertype }) {
    commit("ORDER_TYPE", {
      ordertype,
      commit,
    });
  },

  async saveCartStatus({ commit }, { cart_stat }) {
    commit("CHANGE_CART_STATUS", {
      cart_stat,
      commit,
    });
  },
  async saveDistance({ commit }, { deliverydistance }) {
    commit("ORDER_DISTANCE", {
      deliverydistance,
      commit,
    });
  },
  async resetCartState({ commit }) {
    commit("resetState");
  },
  async saveOrderLater({ commit }, { order_later }) {
    commit("order_later", {
      order_later,
      commit,
    });
  },
  async saveOrderNow({ commit }, { order_now }) {
    commit("order_now", {
      order_now,
      commit,
    });
  },

  async saveOrderDate({ commit }, { order_date }) {
    commit("order_date", {
      order_date,
      commit,
    });
  },

  async saveOrderTime({ commit }, { order_time }) {
    commit("order_time", {
      order_time,
      commit,
    });
  },

  async saveCoupanCodeName({ commit }, { coupon_code_name }) {
    commit("SET_COUPAN_CODE_NAME", {
      coupon_code_name,
      commit,
    });
  },

  async saveCoupanCodeAmount({ commit }, { applied_promo_disc_amt }) {
    commit("SET_COUPAN_CODE_AMOUNT", {
      applied_promo_disc_amt,
      commit,
    });
  },

  async saveCoupanCodeID({ commit }, { coupan_code_id }) {
    commit("SET_COUPAN_CODE_ID", {
      coupan_code_id,
      commit,
    });
  },

  async saveCoupanCodeType({ commit }, { coupon_code_type }) {
    commit("SET_COUPAN_CODE_TYPE", {
      coupon_code_type,
      commit,
    });
  },
};

const mutations = {
  ADD_TO_CART: (state, { item, quantity, commit }) => {
    // console.log("in ADD_TO_CART")

    let productInCart = state.cart.find((cartitems) => {
      if (item.items.order_child_options) {
        return cartitems.item.items.add_opt_title === item.items.add_opt_title;
      } else {
        return cartitems.item.items.item_id === item.items.item_id;
      }
    });
    let qty = quantity;

    if (productInCart) {
      // console.log("product already in cart")

      productInCart.quantity += quantity;

      qty = productInCart.quantity;

      if (menuItems.state.charges.length > 0) {
        menuItems.state.charges.find((addCharges) => {
          //console.log("Charge applicable on " + addCharges.charge_applicable_on)

          if (
            addCharges.charge_applicable_on === 1 ||
            addCharges.charge_applicable_on === 2
          ) {
            let applicable_on_items = JSON.stringify(
              addCharges.applicable_on_items
            );

            //   var str_array = applicable_on_items.split(',');
            /*
                        for (var i = 0; i < str_array.length; i++) {
*/

            //str_array
            //console.log("In for loop product in cart")

            // if (str_array[i] == item.items.item_id)

            if (applicable_on_items.indexOf(item.items.item_id) > -1) {
              if (item.items.order_child_options) {
                //  console.log("order_child_options Present")

                //                              console.log("productInCart.item.items.addon_optgrp_price "+productInCart.item.items.addon_optgrp_price)
                //productInCart.item.items.addon_optgrp_price = productInCart.item.items.addon_optgrp_price + 1

                let cart_addon_optgrp_price =
                  productInCart.item.items.addon_optgrp_price;

                let add_charge_title = addCharges.title;

                let add_charge_fixed_per = addCharges.per_or_fixed;

                //  let discount_type = productInCart.item.items.discount_type
                //let discount_rate = productInCart.item.items.discount_rate

                //// console.log("Discount type "+discount_type)
                // console.log("Discount rate "+discount_rate)

                if (add_charge_fixed_per == 0) {
                  //   console.log("add_charge_fixed_per")
                  productInCart.add_charge.find((prod_in) => {
                    let discounted_price = item.items.discounted_price;

                    let discount_type = item.items.discount_type;
                    let discount_rate = item.items.discount_rate;
                    let calculated_discount;

                    if (discounted_price == 0) {
                      prod_in.calculated_charge_amt = qty * addCharges.amount;

                      //  console.log("prod_in.calculated_charge_amt "+prod_in.calculated_charge_amt)
                    } else {
                      prod_in.calculated_charge_amt = qty * addCharges.amount;

                      if (discount_type == 1) {
                        calculated_discount =
                          Math.round(
                            (((cart_addon_optgrp_price * qty) / 100) *
                              discount_rate +
                              Number.EPSILON) *
                              100
                          ) / 100;

                        //   console.log("111 calculated_discount "+calculated_discount)
                        /// console.log("111 cart_addon_optgrp_price "+cart_addon_optgrp_price)
                        calculated_discount =
                          cart_addon_optgrp_price * qty - calculated_discount;
                        // console.log("discount_calculate_price "+calculated_discount)
                      } else {
                        // console.log("In discount type 0")
                        calculated_discount =
                          cart_addon_optgrp_price * qty - discount_rate;

                        // console.log("calculated_discount In discount type 0 "+calculated_discount)
                      }

                      productInCart.item.items.discount_calculated_on_add_opt = calculated_discount;
                    }
                  });
                } else {
                  //  console.log("charge is fixed or not else")

                  productInCart.add_charge.find((prod_in) => {
                    if (add_charge_title == prod_in.add_charge_title) {
                      let discounted_price = item.items.discounted_price;
                      let discount_type = item.items.discount_type;
                      let discount_rate = item.items.discount_rate;
                      let calculated_discount;

                      if (discounted_price == 0) {
                        //    console.log("discount price")

                        prod_in.calculated_charge_amt =
                          Math.round(
                            (((cart_addon_optgrp_price * qty) / 100) *
                              addCharges.amount +
                              Number.EPSILON) *
                              100
                          ) / 100;
                      } else {
                        // console.log("In discount")
                        if (discount_type == 1) {
                          calculated_discount =
                            Math.round(
                              (((cart_addon_optgrp_price * qty) / 100) *
                                discount_rate +
                                Number.EPSILON) *
                                100
                            ) / 100;
                          //   console.log("222 qty "+qty)
                          //     console.log("222 calculated_discount "+calculated_discount)
                          //  console.log("222 cart_addon_optgrp_price "+cart_addon_optgrp_price)
                          //console.log("calculated_discount "+calculated_discount)
                          calculated_discount =
                            cart_addon_optgrp_price * qty - calculated_discount;
                          //  console.log("discount_calculate_price "+calculated_discount)
                        } else {
                          //  console.log("In discount type 0")
                          calculated_discount =
                            cart_addon_optgrp_price * qty - discount_rate;

                          //    console.log("calculated_discount In discount type 0 "+calculated_discount)
                        }

                        calculated_discount = cart_addon_optgrp_price * qty;

                        //  console.log("222 new calculated_discount "+calculated_discount)
                        productInCart.item.items.discount_calculated_on_add_opt = calculated_discount;
                        prod_in.calculated_charge_amt =
                          Math.round(
                            ((calculated_discount / 100) * addCharges.amount +
                              Number.EPSILON) *
                              100
                          ) / 100;
                      }
                    }
                  });
                }
              } else {
                //   console.log("order_child_options absent")

                let add_charge_title = addCharges.title;
                let add_charge_fixed_per = addCharges.per_or_fixed;

                if (add_charge_fixed_per == 0) {
                  //  console.log("add_charge_fixed_per")
                  productInCart.add_charge.find((prod_in) => {
                    let discounted_price = item.items.discounted_price;

                    if (discounted_price == 0) {
                      /*  prod_in.calculated_charge_amt = Math.round(((((item.items.sale_price * qty) / 100) * addCharges.amount) + Number.EPSILON) * 100) / 100
    
                                                console.log("prod_in.calculated_charge_amt "+prod_in.calculated_charge_amt)*/

                      prod_in.calculated_charge_amt = qty * addCharges.amount;
                    } else {
                      prod_in.calculated_charge_amt = qty * addCharges.amount;
                      // prod_in.calculated_charge_amt = Math.round(((((discounted_price * qty) / 100) * addCharges.amount) + Number.EPSILON) * 100) / 100
                    }
                  });
                } else {
                  //   console.log("add_charge_fixed_per no")
                  //  add_charge_amt = addCharges.amount + "%"

                  productInCart.add_charge.find((prod_in) => {
                    if (add_charge_title == prod_in.add_charge_title) {
                      let discounted_price = item.items.discounted_price;

                      if (discounted_price == 0) {
                        prod_in.calculated_charge_amt =
                          Math.round(
                            (((item.items.sale_price * qty) / 100) *
                              addCharges.amount +
                              Number.EPSILON) *
                              100
                          ) / 100;
                      } else {
                        prod_in.calculated_charge_amt =
                          Math.round(
                            (((discounted_price * qty) / 100) *
                              addCharges.amount +
                              Number.EPSILON) *
                              100
                          ) / 100;
                      }
                    }
                  });
                }
              }
            } else {
              if (item.items.order_child_options) {
                let cart_addon_optgrp_price =
                  productInCart.item.items.addon_optgrp_price;

                //  console.log("Discount type "+discount_type)
                //  console.log("Discount rate "+discount_rate)

                let discounted_price = item.items.discounted_price;
                let discount_type = item.items.discount_type;
                let discount_rate = item.items.discount_rate;
                let calculated_discount;

                if (discounted_price == 0) {
                  //  console.log('No discount')
                } else {
                  if (discount_type == 1) {
                    calculated_discount =
                      Math.round(
                        (((cart_addon_optgrp_price * qty) / 100) *
                          discount_rate +
                          Number.EPSILON) *
                          100
                      ) / 100;
                    ////  console.log("222 qty "+qty)
                    //console.log("222 calculated_discount "+calculated_discount)
                    // console.log("222 cart_addon_optgrp_price "+cart_addon_optgrp_price)
                    //console.log("calculated_discount "+calculated_discount)
                    calculated_discount =
                      cart_addon_optgrp_price * qty - calculated_discount;
                    // console.log("discount_calculate_price "+calculated_discount)
                  } else {
                    //  console.log("In discount type 0")
                    calculated_discount =
                      cart_addon_optgrp_price * qty - discount_rate;

                    //   console.log("calculated_discount In discount type 0 "+calculated_discount)
                  }

                  calculated_discount = cart_addon_optgrp_price * qty;

                  productInCart.item.items.discount_calculated_on_add_opt = calculated_discount;
                }
                // break
              }
            }

            /* }*/
          } else {
            //  console.log("Product in cart charge only on order level")

            if (item.items.order_child_options) {
              let cart_addon_optgrp_price =
                productInCart.item.items.addon_optgrp_price;

              //   console.log("Discount type "+discount_type)
              // console.log("Discount rate "+discount_rate)

              let discounted_price = item.items.discounted_price;
              let discount_type = item.items.discount_type;
              let discount_rate = item.items.discount_rate;
              let calculated_discount;

              if (discounted_price == 0) {
                //   console.log('No discount')
              } else {
                if (discount_type == 1) {
                  calculated_discount =
                    Math.round(
                      (((cart_addon_optgrp_price * qty) / 100) * discount_rate +
                        Number.EPSILON) *
                        100
                    ) / 100;
                  ////  console.log("222 qty "+qty)
                  //  console.log("222 calculated_discount "+calculated_discount)
                  // console.log("222 cart_addon_optgrp_price "+cart_addon_optgrp_price)
                  //console.log("calculated_discount "+calculated_discount)
                  calculated_discount =
                    cart_addon_optgrp_price * qty - calculated_discount;
                  //  console.log("discount_calculate_price "+calculated_discount)
                } else {
                  // console.log("In discount type 0")
                  calculated_discount =
                    cart_addon_optgrp_price * qty - discount_rate;

                  //  console.log("calculated_discount In discount type 0 "+calculated_discount)
                }

                calculated_discount = cart_addon_optgrp_price * qty;

                productInCart.item.items.discount_calculated_on_add_opt = calculated_discount;
              }
            }
          }
        });
      } else {
        //  console.log("Product in cart no add charge")
        if (item.items.order_child_options) {
          let cart_addon_optgrp_price =
            productInCart.item.items.addon_optgrp_price;

          //   console.log("Discount type "+discount_type)
          // console.log("Discount rate "+discount_rate)

          let discounted_price = item.items.discounted_price;
          let discount_type = item.items.discount_type;
          let discount_rate = item.items.discount_rate;
          let calculated_discount;

          if (discounted_price == 0) {
            //  console.log('No discount')
          } else {
            if (discount_type == 1) {
              calculated_discount =
                Math.round(
                  (((cart_addon_optgrp_price * qty) / 100) * discount_rate +
                    Number.EPSILON) *
                    100
                ) / 100;
              ////  console.log("222 qty "+qty)
              //console.log("222 calculated_discount "+calculated_discount)
              // console.log("222 cart_addon_optgrp_price "+cart_addon_optgrp_price)
              //console.log("calculated_discount "+calculated_discount)
              calculated_discount =
                cart_addon_optgrp_price * qty - calculated_discount;
              //  console.log("discount_calculate_price "+calculated_discount)
            } else {
              // console.log("In discount type 0")
              calculated_discount =
                cart_addon_optgrp_price * qty - discount_rate;

              //  console.log("calculated_discount In discount type 0 "+calculated_discount)
            }

            calculated_discount = cart_addon_optgrp_price * qty;

            productInCart.item.items.discount_calculated_on_add_opt = calculated_discount;
          }
        }
      }

      // console.log("Cart is in item already present "+ JSON.stringify(state.cart))
      commit("saveCartToLocalStorage");
      return;
    }

    let add_charge = [];
    let opt_add_price = 0;
    let discount_calculate_price = 0;
    let original_price = 0;

    //  console.log("Charges are "+JSON.stringify(menuItems.state.charges))
    //   console.log("Charges length is "+menuItems.state.charges.length)

    if (menuItems.state.charges.length > 0) {
      menuItems.state.charges.find((addCharges) => {
        if (
          addCharges.charge_applicable_on == 1 ||
          addCharges.charge_applicable_on == 2
        ) {
          let applicable_on_items = JSON.stringify(
            addCharges.applicable_on_items
          );

          //   console.log("applicable_on_items "+applicable_on_items)
          //  console.log("item_id "+item.items.item_id)

          if (applicable_on_items.indexOf(item.items.item_id) > -1) {
            //   console.log("index "+applicable_on_items.indexOf(item.items.item_id) > -1)
            if (item.items.order_child_options) {
              //   console.log("Contains opt add ")

              let is_opt_grp_available = 0;

              item.items.order_child_options.forEach((opt_add) => {
                //    console.log("opt_add "+ JSON.stringify(opt_add))

                if (opt_add.is_addon == 0) {
                  //   console.log("1 opt_add.price "+ opt_add.price)
                  original_price += opt_add.price;

                  //  console.log("2 original_price "+ original_price)

                  let discounted_price = item.items.discounted_price;
                  let discount_type = item.items.discount_type;
                  let discount_rate = item.items.discount_rate;
                  let calculated_discount;

                  if (discounted_price == 0) {
                    //   console.log("1 opt_add_price "+opt_add_price)
                    opt_add_price = opt_add.price;
                    //  console.log("2 opt_add_price "+opt_add_price)
                    // console.log("1 opt_add.price "+opt_add.price)
                  } else {
                    //    console.log("discount available")
                    if (discount_type == 1) {
                      ////  console.log("111 opt_add_price "+ opt_add.price)
                      //  console.log("111 discount_rate "+ discount_rate)

                      calculated_discount =
                        Math.round(
                          ((opt_add.price / 100) * discount_rate +
                            Number.EPSILON) *
                            100
                        ) / 100;
                      // console.log("111 calculated_discount "+ calculated_discount)

                      //   console.log("calculated_discount "+calculated_discount)
                      discount_calculate_price =
                        opt_add.price - calculated_discount;
                      // console.log("111 discount_calculate_price "+discount_calculate_price)
                    } else {
                      discount_calculate_price = opt_add.price - discount_rate;

                      //  console.log("discount_calculate_price "+discount_calculate_price)
                    }
                  }

                  opt_add_price += discount_calculate_price;

                  // console.log("2222 discount_calculate_price "+discount_calculate_price)
                  //  console.log("Option group "+is_opt_grp_available)
                  is_opt_grp_available = is_opt_grp_available + 1;
                } else {
                  //  console.log("Add on")

                  original_price += opt_add.price;
                  opt_add_price += opt_add.price;
                }
                // console.log("First opt_add_price "+opt_add_price)

                discount_calculate_price = opt_add_price;
              });

              if (is_opt_grp_available == 0) {
                //  console.log("item.items sale_price "+item.items.sale_price)

                let discounted_price = item.items.discounted_price;
                //  let discount_type = item.items.discount_type
                // let discount_rate = item.items.discount_rate
                // let calculated_discount

                if (discounted_price == 0) {
                  original_price += item.items.sale_price;
                  opt_add_price = opt_add_price + item.items.sale_price;
                } else {
                  original_price += item.items.discounted_price;

                  opt_add_price = opt_add_price + item.items.discounted_price;
                  discount_calculate_price = opt_add_price;
                }
              }
              let add_charge_title = addCharges.title;
              let add_charge_amt;
              let add_charge_fixed_per = addCharges.per_or_fixed;

              let calculated_charge_amt;

              if (add_charge_fixed_per == 0) {
                add_charge_amt = addCharges.amount;
                calculated_charge_amt = add_charge_amt * qty;
              } else {
                add_charge_amt = addCharges.amount + "%";

                calculated_charge_amt =
                  Math.round(
                    (((opt_add_price * qty) / 100) * addCharges.amount +
                      Number.EPSILON) *
                      100
                  ) / 100;
              }

              /*  add_charge.push({
                                    add_charge_title,
                                    add_charge_amt,
                                    add_charge_fixed_per,
                                    calculated_charge_amt
                                })*/

              add_charge.push({
                add_charge_title,
                add_charge_amt,
                add_charge_fixed_per,
                calculated_charge_amt,
                title: add_charge_title,
                amount: addCharges.amount,
                per_or_fixed: addCharges.per_or_fixed,
                is_default: addCharges.is_default,
                applicable_on_items: addCharges.applicable_on_items,
                calculate_tax_for_item_charges:
                  addCharges.calculate_tax_for_item_charges,
                charge_applicable_on: addCharges.charge_applicable_on,
                digi_order_type: addCharges.digi_order_type,
                delivery_applicable_platform:
                  addCharges.delivery_applicable_platform,
                is_tax_applicable: addCharges.is_tax_applicable,
                tax_amount: addCharges.tax_amount,
                is_tax_included: addCharges.is_tax_included,
                //delivery_free_afteramount: addCharges.title,
                calculated_charge: calculated_charge_amt,
                charge_amount: addCharges.amount,
                charge_title: addCharges.title,
                per_fixed: addCharges.per_or_fixed,
                calculated_tax: 0,
              });

              //  console.log("add_charge "+JSON.stringify(add_charge))

              // console.log("Second opt_add_price "+opt_add_price)
            } else {
              // console.log("Not Contains opt add ")
              let add_charge_title = addCharges.title;
              let add_charge_amt;
              let add_charge_fixed_per = addCharges.per_or_fixed;

              let calculated_charge_amt;

              if (add_charge_fixed_per == 0) {
                add_charge_amt = addCharges.amount;
                calculated_charge_amt = add_charge_amt * qty;
              } else {
                add_charge_amt = addCharges.amount + "%";

                let discounted_price = item.items.discounted_price;

                if (discounted_price == 0) {
                  calculated_charge_amt =
                    Math.round(
                      (((item.items.sale_price * qty) / 100) *
                        addCharges.amount +
                        Number.EPSILON) *
                        100
                    ) / 100;
                } else {
                  calculated_charge_amt =
                    Math.round(
                      (((discounted_price * qty) / 100) * addCharges.amount +
                        Number.EPSILON) *
                        100
                    ) / 100;
                }
              }

              //  console.log("calculated charge array "+JSON.stringify(state.cart.item))
              /*add_charge.push({
                                    add_charge_title,
                                    add_charge_amt,
                                    add_charge_fixed_per,
                                    calculated_charge_amt
                                })*/

              add_charge.push({
                add_charge_title,
                add_charge_amt,
                add_charge_fixed_per,
                calculated_charge_amt,
                title: add_charge_title,
                amount: addCharges.amount,
                per_or_fixed: addCharges.per_or_fixed,
                is_default: addCharges.is_default,
                applicable_on_items: addCharges.applicable_on_items,
                calculate_tax_for_item_charges:
                  addCharges.calculate_tax_for_item_charges,
                charge_applicable_on: addCharges.charge_applicable_on,
                digi_order_type: addCharges.digi_order_type,
                delivery_applicable_platform:
                  addCharges.delivery_applicable_platform,
                is_tax_applicable: addCharges.is_tax_applicable,
                tax_amount: addCharges.tax_amount,
                is_tax_included: addCharges.is_tax_included,
                //delivery_free_afteramount: addCharges.title,
                calculated_charge: calculated_charge_amt,
                charge_amount: addCharges.amount,
                charge_title: addCharges.title,
                per_fixed: addCharges.per_or_fixed,
                calculated_tax: 0,
              });
            }
          } else {
            if (item.items.order_child_options) {
              let is_opt_grp_available = 0;

              item.items.order_child_options.forEach((opt_add) => {
                //   console.log("opt_add " + opt_add.is_addon)

                if (opt_add.is_addon == 0) {
                  //   console.log("abc")

                  //   console.log("opt_add.price "+opt_add.price)

                  original_price += opt_add.price;

                  //    console.log("original_price "+original_price)

                  let discounted_price = item.items.discounted_price;
                  let discount_type = item.items.discount_type;
                  let discount_rate = item.items.discount_rate;
                  let calculated_discount;

                  if (discounted_price == 0) {
                    opt_add_price += opt_add.price;
                  } else {
                    //  console.log("discount available")
                    if (discount_type == 1) {
                      //  console.log("111 opt_add_price "+ opt_add.price)
                      //   console.log("111 discount_rate "+ discount_rate)

                      calculated_discount =
                        Math.round(
                          ((opt_add.price / 100) * discount_rate +
                            Number.EPSILON) *
                            100
                        ) / 100;
                      //  console.log("111 calculated_discount "+ calculated_discount)

                      //   console.log("calculated_discount "+calculated_discount)
                      discount_calculate_price =
                        opt_add.price - calculated_discount;
                      //  console.log("111 discount_calculate_price "+discount_calculate_price)
                    } else {
                      discount_calculate_price = opt_add.price - discount_rate;

                      // console.log("discount_calculate_price "+discount_calculate_price)
                    }

                    opt_add_price += discount_calculate_price;
                  }

                  //   console.log("2222 discount_calculate_price "+discount_calculate_price)
                  //console.log("Option group "+is_opt_grp_available)
                  is_opt_grp_available = is_opt_grp_available + 1;
                } else {
                  // console.log("Add on")

                  original_price += opt_add.price;
                  opt_add_price += opt_add.price;

                  //  console.log("original_price "+original_price)
                  // console.log("opt_add.price "+opt_add.price)
                  // console.log("opt_add_price "+opt_add_price)
                }
                // console.log("First opt_add_price " + opt_add_price)

                discount_calculate_price = opt_add_price;
              });

              if (is_opt_grp_available == 0) {
                //  console.log("item.items sale_price "+item.items.sale_price)

                let discounted_price = item.items.discounted_price;
                //  let discount_type = item.items.discount_type
                // let discount_rate = item.items.discount_rate
                // let calculated_discount

                if (discounted_price == 0) {
                  original_price += item.items.sale_price;
                  opt_add_price = opt_add_price + item.items.sale_price;
                } else {
                  original_price += item.items.discounted_price;
                  //  original_price += (opt_add_price + item.items.discounted_price)
                  opt_add_price = opt_add_price + item.items.discounted_price;
                  discount_calculate_price = opt_add_price;
                }
              }

              //break
            }
          }
          /*}*/
        } else {
          // console.log("charge available only on order")

          if (item.items.order_child_options) {
            //  console.log("childs are present")

            //console.log("productInCart "+JSON.stringify(productInCart))

            let is_opt_grp_available = 0;

            item.items.order_child_options.forEach((opt_add) => {
              //  console.log("opt_add "+ JSON.stringify(opt_add))

              if (opt_add.is_addon == 0) {
                original_price += opt_add.price;
                let discounted_price = item.items.discounted_price;
                let discount_type = item.items.discount_type;
                let discount_rate = item.items.discount_rate;
                let calculated_discount;

                if (discounted_price == 0) {
                  opt_add_price += opt_add.price;
                } else {
                  //  console.log("discount available")
                  if (discount_type == 1) {
                    ///  console.log("111 opt_add_price "+ opt_add.price)
                    //  console.log("111 discount_rate "+ discount_rate)

                    calculated_discount =
                      Math.round(
                        ((opt_add.price / 100) * discount_rate +
                          Number.EPSILON) *
                          100
                      ) / 100;
                    // console.log("111 calculated_discount "+ calculated_discount)

                    //   console.log("calculated_discount "+calculated_discount)
                    discount_calculate_price =
                      opt_add.price - calculated_discount;
                    //  console.log("111 discount_calculate_price "+discount_calculate_price)

                    opt_add_price += discount_calculate_price;
                  } else {
                    discount_calculate_price = opt_add.price - discount_rate;

                    opt_add_price += discount_calculate_price;
                    //console.log("discount_calculate_price "+discount_calculate_price)
                  }
                }

                // console.log("2222 discount_calculate_price "+discount_calculate_price)
                //  console.log("Option group "+is_opt_grp_available)
                is_opt_grp_available = is_opt_grp_available + 1;
              } else {
                // console.log("Add on")

                original_price += opt_add.price;
                opt_add_price += opt_add.price;
              }
              //console.log("First opt_add_price "+opt_add_price)

              discount_calculate_price = opt_add_price;
            });

            if (is_opt_grp_available == 0) {
              //  console.log("item.items sale_price "+item.items.sale_price)

              let discounted_price = item.items.discounted_price;
              //  let discount_type = item.items.discount_type
              // let discount_rate = item.items.discount_rate
              // let calculated_discount

              // console.log("original_price "+original_price)

              if (discounted_price == 0) {
                original_price += item.items.sale_price;
                opt_add_price = opt_add_price + item.items.sale_price;
              } else {
                original_price += item.items.discounted_price;
                opt_add_price = opt_add_price + item.items.discounted_price;
                discount_calculate_price = opt_add_price;
              }
            }
          }
        }
      });
    } else {
      // console.log("no additional charge")

      if (item.items.order_child_options) {
        //   console.log("childs are present")

        //console.log("productInCart "+JSON.stringify(productInCart))

        let is_opt_grp_available = 0;

        item.items.order_child_options.forEach((opt_add) => {
          //  console.log("opt_add "+ JSON.stringify(opt_add))

          if (opt_add.is_addon == 1) {
            //    console.log("Add on")

            //    console.log("222opt_add.price "+opt_add.price)

            original_price += opt_add.price;
            //      console.log("111original_price "+original_price)
            opt_add_price += opt_add.price;

            //     console.log("333opt_add.price "+opt_add.price)
          } else {
            //   console.log("opt_add.price "+original_price)

            original_price += opt_add.price;
            let discounted_price = item.items.discounted_price;
            let discount_type = item.items.discount_type;
            let discount_rate = item.items.discount_rate;
            let calculated_discount;

            if (discounted_price == 0) {
              opt_add_price += opt_add.price;

              //  console.log("new opt_add.price "+opt_add.price)
            } else {
              //  console.log("discount available")
              if (discount_type == 1) {
                //  console.log("111 opt_add_price "+ opt_add.price)
                //   console.log("111 discount_rate "+ discount_rate)

                calculated_discount =
                  Math.round(
                    ((opt_add.price / 100) * discount_rate + Number.EPSILON) *
                      100
                  ) / 100;
                //  console.log("111 calculated_discount "+ calculated_discount)

                //   console.log("calculated_discount "+calculated_discount)
                discount_calculate_price = opt_add.price - calculated_discount;
                //  console.log("111 discount_calculate_price "+discount_calculate_price)

                opt_add_price += discount_calculate_price;
              } else {
                discount_calculate_price = opt_add.price - discount_rate;

                opt_add_price += discount_calculate_price;
                //  console.log("discount_calculate_price "+discount_calculate_price)
              }
            }

            // console.log("111opt_add.price "+discount_calculate_price)

            ////  console.log("2222 discount_calculate_price "+discount_calculate_price)
            //console.log("Option group "+is_opt_grp_available)
            is_opt_grp_available = is_opt_grp_available + 1;
          }
          // console.log("First opt_add_price "+opt_add_price)

          discount_calculate_price = opt_add_price;
        });

        if (is_opt_grp_available == 0) {
          // console.log("item.items sale_price "+item.items.sale_price)

          let discounted_price = item.items.discounted_price;
          //  let discount_type = item.items.discount_type
          // let discount_rate = item.items.discount_rate
          // let calculated_discount

          // console.log("original_price "+original_price)

          if (discounted_price == 0) {
            original_price += item.items.sale_price;
            opt_add_price = opt_add_price + item.items.sale_price;
          } else {
            original_price += item.items.discounted_price;
            opt_add_price = opt_add_price + item.items.discounted_price;
            discount_calculate_price = opt_add_price;
          }
        }
      }
    }

    if (menuItems.state.charges.length > 0) {
      item.items["addon_optgrp_price"] =
        opt_add_price / menuItems.state.charges.length;
    } else {
      item.items["addon_optgrp_price"] = opt_add_price;
    }

    item.items["discount_calculated_on_add_opt"] = discount_calculate_price;
    item.items["original_price"] = original_price;

    // console.log("Item is "+ JSON.stringify(item))
    state.cart.push({
      item,
      quantity,
      add_charge,
    });

    //         console.log("Cart is "+ JSON.stringify(state.cart))

    //console.log(commit)
    commit("saveCartToLocalStorage");
  },

  REMOVE_PRODUCT_FROM_CART: (state, { item_id, commit, item }) => {
    state.cart = state.cart.filter((cartitems) => {
      if (
        item.addon_optgrp_price == 0 ||
        item.addon_optgrp_price == undefined
      ) {
        return cartitems.item.items.item_id !== item_id;
      } else {
        return cartitems.item.items.add_opt_title !== item.add_opt_title;
      }
    });

    //console.log(commit)
    commit("saveCartToLocalStorage");
  },

  CLEAR_CART_ITEMS: (state, { commit }) => {
    state.cart = [];
    //console.log(commit)
    commit("saveCartToLocalStorage");
  },

  DELETE_PRODUCT_FROM_CART: (state, { item_id, quantity, commit, item }) => {
    /*let productInCart = state.cart.find(item => {
            return item.item_id === item_id;
        });*/

    state;
    commit;
    item_id;
    quantity;
    //  console.log("item is in DELETE_PRODUCT_FROM_CART "+JSON.stringify(item))

    //alert(JSON.stringify(item))

    let sale_price = 0;
    let productInCart = state.cart.find((cartitems) => {
      // console.log("DELETE_PRODUCT_FROM_CART product in cart " + item.addon_optgrp_price)
      if (
        item.addon_optgrp_price == 0 ||
        item.addon_optgrp_price == undefined
      ) {
        //  console.log("DELETE_PRODUCT_FROM_CART addon_optgrp_price is zero")

        if (cartitems.item.items.item_id === item_id) {
          //  console.log("ID is same")

          let discounted_price = cartitems.item.items.discounted_price;

          //  console.log("discounted_price is " + discounted_price)

          if (discounted_price == 0) {
            sale_price = cartitems.item.items.sale_price;
          } else {
            sale_price = discounted_price;
          }
        }
        return cartitems.item.items.item_id === item_id;
      } else {
        //  console.log("addon_optgrp_price is greater than zero")

        if (cartitems.item.items.add_opt_title === item.add_opt_title) {
          //  console.log("title is same")

          let discounted_price = cartitems.item.items.discounted_price;

          //  console.log("discounted_price is " + discounted_price)

          if (discounted_price == 0) {
            sale_price = cartitems.item.items.addon_optgrp_price;
          } else {
            sale_price =
              cartitems.item.items.discount_calculated_on_add_opt /
              cartitems.quantity;

            //  console.log("sale_price is "+sale_price)
          }
        }

        return cartitems.item.items.add_opt_title === item.add_opt_title;
      }
    });

    let qty = quantity;
    qty;
    sale_price;
    if (productInCart) {
      productInCart.quantity -= quantity;

      if (
        item.addon_optgrp_price > 0 &&
        item.discount_calculated_on_add_opt > 0
      ) {
        productInCart.item.items.discount_calculated_on_add_opt =
          productInCart.quantity * sale_price;

        //   console.log("productInCart.item.items.discount_calculated_on_add_opt "+productInCart.item.items.discount_calculated_on_add_opt)
      }

      qty = productInCart.quantity;
      //sale_price = productInCart.sale_price

      let cal_sale_price = sale_price;
      // console.log("Sale price is " + sale_price)

      menuItems.state.charges.find((addCharges) => {
        // console.log("Charge applicable on "+ addCharges.charge_applicable_on)

        if (
          addCharges.charge_applicable_on == 1 ||
          addCharges.charge_applicable_on == 2 ||
          addCharges.charge_applicable_on == 0
        ) {
          let applicable_on_items = JSON.stringify(
            addCharges.applicable_on_items
          );

          //  var str_array = applicable_on_items.split(',');

          //   str_array
          /*                  for (var i = 0; i < str_array.length; i++) {
           */
          //if (str_array[i] == item_id)
          applicable_on_items.indexOf(item.items.item_id) > -1;
          {
            let add_charge_title = addCharges.title;
            let add_charge_amt;
            let add_charge_fixed_per = addCharges.per_or_fixed;

            if (add_charge_fixed_per == 0) {
              add_charge_amt = addCharges.amount;
              productInCart.add_charge.find((prod_in) => {
                if (add_charge_title == prod_in.add_charge_title) {
                  prod_in.calculated_charge_amt = add_charge_amt * qty;
                }
              });
            } else {
              add_charge_amt = addCharges.amount + "%";

              productInCart.add_charge.find((prod_in) => {
                //  console.log("cal_sale_price is " + cal_sale_price)
                //console.log("calculated charge amt is " + prod_in.calculated_charge_amt)
                //  console.log("add charge amt is " + addCharges.amount)

                if (add_charge_title == prod_in.add_charge_title) {
                  prod_in.calculated_charge_amt =
                    Math.round(
                      (((cal_sale_price * qty) / 100) * addCharges.amount +
                        Number.EPSILON) *
                        100
                    ) / 100;
                }
              });
            }
          }

          /* }*/
        }
      });

      return;
    }

    // console.log("Cart Item remove qty "+ JSON.stringify(state.cart))
    //  console.log(commit)
    commit("saveCartToLocalStorage");
  },

  ORDER_TYPE: (state, { ordertype }) => {
    state.ordertype = ordertype;
  },

  CHANGE_CART_STATUS: (state, { cart_stat }) => {
    state.cart_status = cart_stat;
  },

  saveCartToLocalStorage(state) {
    localStorage.removeItem("cart");
    //    window.localStorage.setItem('cart',JSON.stringify(state.cart))

    state;
    // let stateTest = state

    //stateTest
    // console.log("In saveCartToLocalStorage "+ JSON.stringify(state.cart))
  },
  ORDER_DISTANCE: (state, { deliverydistance }) => {
    state.distance = deliverydistance;
  },
  resetState(state) {
    // Merge rather than replace so we don't lose observers
    // https://github.com/vuejs/vuex/issues/1118
    Object.assign(state, getDefaultCartState());
  },
  order_later: (state, { order_later }) => {
    state.order_later = order_later;

    localStorage.setItem("order_later", order_later);
  },
  order_now: (state, { order_now }) => {
    state.order_now = order_now;
    localStorage.setItem("order_now", order_now);
  },
  order_date: (state, { order_date }) => {
    state.orderdate = order_date;

    localStorage.setItem("orderdate", order_date);
  },
  order_time: (state, { order_time }) => {
    state.ordertime = order_time;
    localStorage.setItem("ordertime", order_time);
  },
  SET_COUPAN_CODE_NAME: (state, { coupon_code_name }) => {
    state.coupon_code_name = coupon_code_name;
  },
  SET_COUPAN_CODE_AMOUNT: (state, { applied_promo_disc_amt }) => {
    state.applied_promo_disc_amt = applied_promo_disc_amt;
  },

  SET_COUPAN_CODE_ID: (state, { coupan_code_id }) => {
    state.coupan_code_id = coupan_code_id;
  },
  SET_COUPAN_CODE_TYPE: (state, { coupan_code_type }) => {
    state.coupan_code_type = coupan_code_type;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
